import {post} from '../utils/request'

// 销售汇总
export async function getsalesummay(data) {
    return await post('api/v1/smartscreen/getsalesummary',data)
}


// 商品销售排行top15
export async function gettopsaleitem(data) {
    return await post('api/v1/smartscreen/gettopsaleitem',data) 
}

// 类别销售排行top15
export async function gettopsalecategory(data) {
    return await post('api/v1/smartscreen/gettopsalecategory',data) 
}

export async function getsalechanneldistribution(data) {
    return await post('api/v1/smartscreen/getsalechanneldistribution',data) 
}

export async function getpaymentsummary(data) {
    return await post('api/v1/smartscreen/getpaymentsummary',data)
}

export async function gettimeintervalsale(data) {
    return await post('api/v1/smartscreen/gettimeintervalsale',data)
}

export async function getmonthsalesachievement(data) {
    return await post('api/v1/smartscreen/getmonthsalesachievement',data)
}

export async function gettopsalebranch(data) {
    return await post('api/v1/smartscreen/gettopsalebranch',data) 
}

export async function geusersmartscreen(data) {
    return await post('api/v1/smartscreen/geusersmartscreen',data)
}